
import React from "react";
import { Schemes, Utils } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import { Elements } from "../../../shared/Elements";
import { Siren } from "../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, IGallery, IMember, IProfileWebsite, ITournamentEditionRegistered, ITournamentEdition, MemberService, SanitizedResponse, TournamentService, ITournamentEditionRegisteredParticipant } from "../../../../services";
import { Alignment, Button, Checkbox, DOMHelper, Dropdown, Form, FormControl, NoseurObject, ObjectHelper, Scheme, TabPane, TabPanel, TabPaneManageRef, TextAreaInput, TextInput, useSubscription } from "@rivtn/noseur";
import ImportExport from "../../../page_design/ImportExport";
import Merch from "../../../shared/settings/Merch";
import Gallery from "../../../shared/settings/Gallery";
import TourActivities from "./YouTourActivities";
import YourTourHome from "./YourTourHome";
import YourTourCalendar from "./YourTourCalendar";
import YourTourMatchesAndReporting from "./YourTourMatchesAndReporting";

export interface YourTournamentProps {
    profile: IMember;
}

function YourTournament(props: YourTournamentProps) {

    let { id = "" } = ReactRouterDom.useParams();
    const tournamentService = TournamentService.getInstance();
    const tabManageRef = React.useRef<TabPaneManageRef>(null);
    const [profile, _] = React.useState<IMember>(props.profile);
    const labels = i18nManager.Labels.tournaments.your_tournament;
    const tabs = ["HOME", "ACTIVITIES", "CALENDAR", "MATCHES_AND_REPORTING"];
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [tournamentEditionRegisteredParticipant, setTournamentEditionRegisteredParticipant] = React.useState<ITournamentEditionRegisteredParticipant>();
    const switchPageTab = useSubscription("OMNEHOST.YOUR_TOUR.UPDATED", (tab) => {
        tabManageRef.current?.switch(tabs.indexOf(tab));
    });

    React.useEffect(fetchInformation, []);
    React.useEffect(() => {
        if (tabManageRef.current?.activeTab() === undefined || tabManageRef.current?.activeTab() === tabs.indexOf(searchParams.get("tab") ?? "HOME")) {
            return;
        }
        switchPageTab(searchParams.get("tab"));
    }, [searchParams]);

    return (<div className="settings earnings analytics your-tour">
        <div className="header">
            <div className="l" style={{ display: "flex", flexDirection: "row" }}>
                <i className="fa fa-arrow-left" style={{ marginTop: 10 }} onClick={() => window.history.back()} />
                <img style={{ width: 45, height: 45, marginLeft: 15, borderRadius: "100%" }} src={tournamentEditionRegisteredParticipant?.tournament_edition_registered?.tournament_edition ? tournamentEditionRegisteredParticipant.tournament_edition_registered?.tournament_edition?.logo_url : LoadingGif} />
                <div style={{ display: "flex", flexDirection: "column", marginLeft: 15, }}>
                    <span className="t lined-limit" style={{ fontSize: 20, fontWeight: "bold" }}>
                        {tournamentEditionRegisteredParticipant?.tournament_edition_registered?.tournament_edition?.name ?? labels.loading}
                    </span>
                    <span className="lined-limit" style={{ fontWeight: "normal" }}>
                        {labels.tournament} - {id} - <b>{Utils.getResourceName(tournamentEditionRegisteredParticipant?.resource, tournamentEditionRegisteredParticipant?.external_id)}</b>
                    </span>
                </div>
            </div>
        </div>
        {!tournamentEditionRegisteredParticipant
            ? (<div style={{ margin: "auto" }}>
                <img alt={"loading"} src={LoadingGif} style={{ width: 80, margin: "auto" }} />
            </div>)
            : (<TabPane renderActiveTabOnly noUnderline idleScheme={Schemes.IDLE} scheme={Schemes.OMNEHOST} activeIndex={tabs.indexOf(searchParams.get("tab") ?? "HOME")}
                style={{ marginTop: 10, marginLeft: 10, height: "100%" }} attrsRelay={{ content: { style: { margin: 0, padding: 0, border: "none" } } }} onTabActive={(i) => {
                    Utils.updateSearchParams("tab", tabs[i], setSearchParams);
                    if (tabs[i] !== "MATCHES_AND_REPORTING" && searchParams.has("mid")) {
                        Utils.updateSearchParams("a", undefined, setSearchParams);
                        Utils.updateSearchParams("mid", undefined, setSearchParams);
                    }
                }} manageRef={tabManageRef}>

                <TabPanel header={labels.home.title} >
                    <YourTourHome registeredTournamentParticipant={tournamentEditionRegisteredParticipant} />
                </TabPanel>

                <TabPanel header={<>
                    {labels.activities.title}
                    <span className="noseur-badge noseur-danger noseur-no-border" style={{ bottom: 3, right: 10, marginLeft: 8 }}>{tournamentEditionRegisteredParticipant.un_reads?.notifications ?? 0}</span>
                </>} >
                    <TourActivities registeredTournamentParticipant={tournamentEditionRegisteredParticipant} />
                </TabPanel>

                <TabPanel header={labels.calender.title} >
                    <YourTourCalendar registeredTournamentParticipant={tournamentEditionRegisteredParticipant} />
                </TabPanel>

                <TabPanel header={labels.matches_and_reporting.title} >
                    <YourTourMatchesAndReporting registeredTournamentParticipant={tournamentEditionRegisteredParticipant} />
                </TabPanel>
            </TabPane>)}
    </div>);

    function fetchInformation() {
        tournamentService.getSingleTournamentEditionRegistered(id!).then(({ sanitized }: SanitizedResponse<ITournamentEditionRegistered>) => {
            if (sanitized?.un_reads?.notifications && sanitized?.un_reads?.notifications > 9) (sanitized!.un_reads as any).notifications = "9+";
            tournamentService.queryTournamentEditionRegisteredParticipants(sanitized.tournament_edition.external_id, {
                size: 1,
                "tournament_edition_registered.external_id": sanitized.external_id,
            }).then(({ content }: SanitizedResponse<any>) => {
                setTournamentEditionRegisteredParticipant(content[0]);
            }).catch(BaseService.reportError);
        }).catch((error) => {
            BaseService.reportError(error);
        });
    }

}

export default YourTournament;
